import type { IconSvgObject } from './types';

const WpsOfficeIcon: IconSvgObject = [
  ["path", { d: "M13.5 14.5L15.5 18.5H16L22 6V5.5H15L12 11.5L8.5 18.5H8L2 6V5.5H9L10.5 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default WpsOfficeIcon;
